/*
 * Shared scroll-snap carousel controls.
 *
 * Markup contract (any section):
 *   [data-la-carousel]                 root; optional data-step="page" to move a full view
 *     [data-la-carousel-track]         the scrolling row; its children are the slides
 *     [data-la-carousel-nav]           wrapper, hidden automatically when nothing overflows
 *       [data-la-carousel-prev] / [data-la-carousel-next]   buttons
 *       [data-la-carousel-count]       optional "2 / 6" readout (polite live region)
 *
 * The browser does the moving (CSS scroll-snap), so touch, trackpad and keyboard
 * scrolling work without this file; it only adds the buttons and the counter.
 * Used by sections/la-image-cards.liquid, sections/la-image-carousel.liquid and the
 * syrup row in sections/recipe-guide-landing.liquid.
 */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.laCarouselInit) return;
    var track = root.querySelector('[data-la-carousel-track]');
    var nav = root.querySelector('[data-la-carousel-nav]');
    var prev = root.querySelector('[data-la-carousel-prev]');
    var next = root.querySelector('[data-la-carousel-next]');
    var count = root.querySelector('[data-la-carousel-count]');
    if (!track || !nav || !prev || !next) return;
    root.dataset.laCarouselInit = '1';

    var slides = track.children;
    var byPage = root.getAttribute('data-step') === 'page';

    function slideStep() {
      return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
    }
    function step() { return byPage ? track.clientWidth : slideStep(); }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 8;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
      if (count && slides.length) {
        var perView = Math.max(1, Math.round(track.clientWidth / (slideStep() || 1)));
        var first = Math.round(track.scrollLeft / (slideStep() || 1)) + 1;
        if (next.disabled) first = slides.length - perView + 1;
        var last = Math.min(first + perView - 1, slides.length);
        count.textContent = (perView > 1 ? first + '–' + last : first) + ' / ' + slides.length;
      }
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-la-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
